import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-place": "true",
  "data-kt-place-mode": "prepend",
  "data-kt-place-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "\n        menu\n        menu-lg-rounded\n        menu-column\n        menu-lg-row\n        menu-state-bg\n        menu-title-gray-700\n        menu-state-title-primary\n        menu-state-icon-primary\n        menu-state-bullet-primary\n        menu-arrow-gray-400\n        fw-bold\n        my-5 my-lg-0\n        align-items-stretch\n      ",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}